export const cookieConfig = () => {
  // Cookie
  let cookieJson = {};
  try {
    let parsingCookie = JSON.parse(decodeURIComponent(decodeURI(document.cookie.split('; ').find(cookie => cookie.startsWith('xc=')).split('=')[1])));
    if (typeof parsingCookie === 'object' && Array.isArray(parsingCookie) === false && parsingCookie !== null) cookieJson = {...parsingCookie};
  } catch (error) {
    console.log('Cookie not found or invalid. Development mode initiated.');
  }

  const productionURL = window.location.href.includes("beta") ? 'https://beta.xpel.app' : 'https://app.xpel.app';

  // AppProps
  return {
    'authToken': cookieJson.authToken || process.env.REACT_APP_AUTH_TOKEN || 'none',
    'authEnv': cookieJson.env === 'p' ? `${productionURL}/chat` : 'https://sandbox.xpel1.com/chat',
    'backEnv': cookieJson.env === 'p' ? productionURL : 'https://sandbox.xpel1.com'
  };
  // const urlParams = new URLSearchParams(window.location.search);
  // urlParams.get('apiKey') || 'none',
};

export const delayPromise = ms => new Promise(resolve => setTimeout(resolve, ms));

export const notificationInitSW = async () => {
  try {
    const checkNotificationSupport = () => {
      if (!('serviceWorker' in navigator)) throw new Error('No Service Worker support!')
      if (!('PushManager' in window)) throw new Error('No Push API Support!')
    };
    const registerServiceWorker = async () => {
      const swRegistration = await navigator.serviceWorker.register('./sw.js'); //notice the file name
      return swRegistration;
    };
    const requestNotificationPermission = async () => {
      const permission = await window.Notification.requestPermission();
      if (permission !== 'granted') console.log('notifications-permission-not-granted');
    }
    checkNotificationSupport();
    await registerServiceWorker();
    await requestNotificationPermission();
  }
  catch (err) {
    console.log(err.message || err);
  }
};
export const notificationInit = async () => {
  try {
    if (!('PushManager' in window)) throw new Error('No Push API Support!')
    const requestNotificationPermission = async () => {
      const permission = await window.Notification.requestPermission();
      if (permission !== 'granted') console.log('Notifications permission is not granted');
    };
    await requestNotificationPermission();
  }
  catch (err) {
    console.log(err.message || err);
  }
};
export const notificationText = (event, client) => {
  try {
    let title = `New message`;
    let body = '';
    if (event.channel_type === 'direct' && event.type === 'message.new') body = 'Private ' + event.user.name || event.user.id;
    if (event.channel_type === 'direct' && event.type === 'notification.message_new') body = 'Private ' + event.message.user.name || event.message.user.id;
    if (event.channel_type === 'team') {
      let event_channelData = client.activeChannels[event.cid]['data'];
      if (typeof event_channelData.name === 'string' && event_channelData.name.length > 0) body = 'Group ' + event_channelData.name;
      else body = 'Group Unknown';
    }
    if (event.channel_type === 'prime') {
      let event_channelData = client.activeChannels[event.cid]['data'];
      if (!event_channelData) body = 'Channel Unknown';
      else {
        if (event_channelData.channel_type === 'driver') body = '❗ Channel';
        else body = 'Channel';
        if (typeof event_channelData.unitCode === 'string' && event_channelData.unitCode.length > 0 && event_channelData.unitCode) body += ' '+event_channelData.unitCode.split(' ')[0]; //Display first unit code
        if (typeof event_channelData.firstName === 'string') body += ' '+event_channelData.firstName;
        if (typeof event_channelData.lastName === 'string') body += ' '+event_channelData.lastName;
      }
    }
    return {title: title, body: body};
  }
  catch (err) {
    console.log(err.message || err);
  }
}

export const sort_channels_to_list_prime = (a, b) => {
  if (countUnreadPerChannel(a) > countUnreadPerChannel(b)) return -1;
  else if (countUnreadPerChannel(a) < countUnreadPerChannel(b)) return 1;
  else {
    let aMsgAt = a.state.last_message_at === null ? new Date(0) : a.state.last_message_at.getTime();
    let bMsgAt = b.state.last_message_at === null ? new Date(0) : b.state.last_message_at.getTime();
    if (aMsgAt > bMsgAt) return -1;
    else if (aMsgAt < bMsgAt) return 1;
    else {
      if (a.cid > b.cid) return -1;
      else if (a.cid < b.cid) return -1;
      return 0;
    }
  }
};
export const sort_channels_to_list = (a, b) => {
  let aMsgAt = a.state.last_message_at === null ? new Date(0) : a.state.last_message_at.getTime();
  let bMsgAt = b.state.last_message_at === null ? new Date(0) : b.state.last_message_at.getTime();
  if (aMsgAt > bMsgAt) return -1;
  else if (aMsgAt < bMsgAt) return 1;
  else {
    if (a.cid > b.cid) return -1;
    else if (a.cid < b.cid) return -1;
    return 0;
  }
};

export const sort_x_lastMessageAt = (a, b) => {
  if (a.state.last_message_at === null && b.state.last_message_at === null) return 0;
  else if (a.state.last_message_at === null && b.state.last_message_at !== null) return -1;
  else if (a.state.last_message_at !== null && b.state.last_message_at === null) return 1;
  else {
    if (a.state.last_message_at.getTime() > b.state.last_message_at.getTime()) return -1;
    else if (a.state.last_message_at.getTime() < b.state.last_message_at.getTime()) return 1;
    else return 0;
  }
};

export const sort_x_unreadCount = (a, b) => {
  if (countUnreadPerChannel(a) > countUnreadPerChannel(b)) return -1;
  else if (countUnreadPerChannel(a) < countUnreadPerChannel(b)) return 1;
  else return 0;
};

export const countUnreadPerChannel = channel => {
  if (channel.data.type !== 'prime') return channel.state.unreadCount;
  else {
    let unreadTmp = 0;
    if (channel.data.type === 'prime' && channel.state.messages && channel.state.messages.length > 0) {
      for (let i = channel.state.messages.length - 1; i >= 0; i--) {
        const message = channel.state.messages[i];
        if (message.type === 'regular' && message.silent === true) continue;
        if (message.type === 'regular' && message.user.id === 'sms_service') unreadTmp++;
        else if (message.type === 'regular' && message.user.id.startsWith('driver') === true) unreadTmp++;
        else break;
      }
    }
    return unreadTmp;    
  }
};

export const countAllUnreadChannels = channelsMap => {
  let channelsMap_unread = { prime: 0, team: 0, direct: 0 };
  Object.keys(channelsMap).map(ch_cid => {
    let countCheck = countUnreadPerChannel(channelsMap[ch_cid]);
    if (countCheck > 0) channelsMap_unread[channelsMap[ch_cid]['type']] += 1;
    return true;
  });
  return channelsMap_unread;
};

export const prime_badgeColor = (recordType) => {
  switch (recordType) {
      case 'driver':
        return '#74c0fc';
      case 'owner':
        return '#748ffc';
      case 'carrier':
        return '#82c91e';
      case 'facility':
        return '#9775fa';
      default: // other
        return '#868e96';
  }
};

export const getPrimeName = (ch_item) => {
  let name = '';
  if (typeof ch_item.data.firstName === 'string' && ch_item.data.firstName !== '') name += `${ch_item.data.firstName} `;
  if (typeof ch_item.data.lastName === 'string' && ch_item.data.lastName !== '') name += `${ch_item.data.lastName}`;
  if (name === '') {
    if (ch_item.data.channel_type === 'phonebook') name = `${ch_item.data.phoneNumber || ch_item.data.id}`;
    else name = `${ch_item.data.name || ch_item.data.title || ch_item.data.phoneNumber || ch_item.data.id}`;
  }
  return name;
};

export const getChannelName = (channel, clientId) => {
  let ch_name = '';
  if (channel.data.type === 'direct') {
    let mbr = Object.keys(channel.state.members).map(mbr => channel.state.members[mbr]).filter(mbr => mbr.user_id !== clientId)[0];
    if (typeof mbr === 'object' && Array.isArray(mbr) === false && mbr !== null) {
      if (typeof mbr.user === 'object' && Array.isArray(mbr.user) === false && mbr.user !== null) {
        if (mbr.user.name && mbr.user.name.length > 0) ch_name = mbr.user.name;
        else ch_name = mbr.user_id || 'Deleted contact';
      }
    }
    else ch_name = 'Deleted contact';
  }
  else ch_name = channel.data.name || '';
  return ch_name;
};

export const getDirectMembers = (channel) => channel.data.type === 'direct' ? Object.keys(channel.state.members).map(mbr => channel.state.members[mbr]['user_id']) : [];

export const getEpochLastMessageAt = (channel) => typeof channel.data.last_message_at === 'string' ? new Date(channel.data.last_message_at).getTime() : 0;

export const sort_obj_lastMessageAt = (a, b) => {
  if (a.last_message_at > b.last_message_at) return -1;
  else if (a.last_message_at < b.last_message_at) return 1;
  else return 0;
};

export const blobTypeExtension = (blobType) => {
  switch (blobType) {
    case 'image/jpeg':
      return '.jpeg';
    case 'image/png':
      return '.png';
    case 'image/webp':
      return '.webp';
    case 'image/gif':
      return '.gif';
    case 'image/bmp':
      return '.bmp';
    case 'image/heic':
      return '.heic';
    case 'image/heif':
      return '.heif';
    default:
      return '.unknown';
  }
};

export const getServiceUsers = async (client) => {
  try {
    let queryLoop = false;
    let queryFilters = { id: { $nin: [client.userID] }, userType: 'service', banned: false };
    let querySort = [{ last_active: -1 }];
    let queryOptions = { limit: 100, offset: 0, presence: true };
    // -------
    // Users
    let { users: tmp_usersArray } = await client.queryUsers(queryFilters, querySort, queryOptions);
    if (tmp_usersArray.length === queryOptions.limit) queryLoop = true;
    while (queryLoop === true) {
      await delayPromise(200);
      queryOptions.offset += queryOptions.limit;
      let { users: loopUsers } = await client.queryUsers(queryFilters, querySort, queryOptions);
      if (loopUsers.length > 0) tmp_usersArray = [...tmp_usersArray, ...loopUsers];
      if (loopUsers.length === 0 || loopUsers.length < queryOptions.limit) queryLoop = false;
    }
    if (tmp_usersArray.length > 0) {
      // Sort by name
      tmp_usersArray.sort((a, b) => {
        if (a.name < b.name) return -1;
        else if (a.name > b.name) return 1;
        else return 0;
      });
      // Then sort by online
      tmp_usersArray.sort((a, b) => {
        if (a.online === true && b.online === false) return -1;
        else if (a.online === false && b.online === true) return -1;
        else return 0;
      });
      return tmp_usersArray;
    }
    else return false;
  }
  catch (err) {
    console.log('Error', err);
  }
};